import { ActivityReview, GenericImage, LeaveActivityReviewsFragment, RentalUnitReviewFragment, Review, ReviewModal_Booking_Fragment, ReviewModal_Ticket_Fragment } from "../generated/graphql";

export type ReviewData = {
    item: ReviewModal_Booking_Fragment | ReviewModal_Ticket_Fragment;
    review: Review | ActivityReview | null;
    rentalUnit: RentalUnitReviewFragment | null;
    activity: LeaveActivityReviewsFragment | null;
    ownerName: string | null;
    jpeg: GenericImage | null;
    webp: GenericImage | null;
    reviewStats: {
        average: number | null;
        hospitality: number | null;
        layout: number | null;
        location: number | null;
        activity: number | null;
        maintenance: number | null;
        valueForMoney: number | null;
    };
};
export function normalizeReviewData(
    data: ReviewModal_Booking_Fragment | ReviewModal_Ticket_Fragment
): ReviewData | null {
    if (data.__typename === 'Booking') {
        const {rentalUnit, review} = data;

        if (!rentalUnit){
            return null;
        }

        return {
            item: data,
            review: review ?? null,
            rentalUnit,
            activity: null,
            ownerName: rentalUnit?.accommodation.ownerName ?? null,
            jpeg: rentalUnit?.accommodation.jpegOwner ?? null,
            webp: rentalUnit?.accommodation.webpOwner ?? null,
            reviewStats: {
                average: review?.average ?? null,
                hospitality: review?.ratingHospitality ?? null,
                layout: review?.ratingLayout ?? null,
                location: review?.ratingLocation ?? null,
                activity: null,
                maintenance: review?.ratingMaintenance ?? null,
                valueForMoney: review?.ratingValueForMoney ?? null,
            },
        };
    }

    if (data.__typename === 'Ticket') {
        const { activity, activityReview } = data;

        if (!activity) {
            return null;
        }

        return {
            item: data,
            review: activityReview ?? null,
            activity,
            rentalUnit: null,
            ownerName: activity?.name ?? null,
            jpeg: activity?.jpegThumbnail ?? null,
            webp: activity?.webpThumbnail ?? null,
            reviewStats: {
                average: activityReview?.average ?? null,
                hospitality: activityReview?.ratingHospitality ?? null,
                layout: null,
                location: null,
                activity: activityReview?.ratingActivity ?? null,
                maintenance: null,
                valueForMoney: activityReview?.ratingValueForMoney ?? null,
            },
        };
    }

    return null;
}
